// extracted by mini-css-extract-plugin
export default {"series_delete":"SeriesDeleteModal_series_delete__wst1s"};